module.exports = __webpack_public_path__ + "img/18.5c6ec3ce.png";